import { useCallback, useState } from 'react'
import { DateTime } from 'luxon'
import { useHostConfig } from '../../../../hooks/use-host-config'
import { SignaturePad } from '@Components/signature-pad/signature-pad'
import { FormFloatingFooter } from '@Components/claim-flow/form-floating-footer'
import { Button } from '@Components/button/button'
import { StepProps } from '../../types'
import { hasField, getFieldPattern, isFieldRequired } from '../../schema-utils'
import PreviousChevron from '@Assets/icons/previous-chevron.svg'

import './sign-step.scss'

const CLASS_NAME = 'sign-step'
const SECTION = 'signatureAndDate'

export const SignStep = ({ schema, formData, onSubmit, onBack }: StepProps) => {
  const hostConfig = useHostConfig()
  const existing = (formData.signatureAndDate ?? {}) as { signature?: string; date?: string }

  const [signature, setSignature] = useState<string | null>(existing.signature ?? null)

  const now = DateTime.now()
  const todayDateIso = now.toISODate() ?? ''
  const todayDateDisplay = now.toFormat('MM/dd/yyyy')

  const datePattern = getFieldPattern(schema, SECTION, 'date')

  const handleSubmit = useCallback(() => {
    if (!signature) {
      return
    }

    const signatureAndDate: Record<string, unknown> = {}

    if (hasField(schema, SECTION, 'signature')) {
      // Strip data URL prefix — backend expects raw base64
      signatureAndDate.signature = signature.replace(/^data:image\/\w+;base64,/, '')
    }
    if (hasField(schema, SECTION, 'date')) {
      signatureAndDate.date = todayDateIso
    }

    onSubmit({ signatureAndDate })
  }, [schema, signature, todayDateIso, onSubmit])

  return (
    <section className={CLASS_NAME}>
      <h2 className={`${CLASS_NAME}__title`}>Sign & Date</h2>
      <section className={`${CLASS_NAME}__legal-text`}>
        {hostConfig.claimFormConfig?.legalText}
      </section>

      {hasField(schema, SECTION, 'signature') && (
        <SignaturePad
          onSignatureChange={setSignature}
          label={`Signature ${isFieldRequired(schema, SECTION, 'signature') ? '*' : ''}`}
        />
      )}

      {hasField(schema, SECTION, 'date') && (
        <section className={`${CLASS_NAME}__date-field`}>
          <label>Today's Date</label>
          <input type="text" value={todayDateDisplay} readOnly pattern={datePattern} />
        </section>
      )}

      <FormFloatingFooter>
        <section className="floating-footer__buttons">
          <Button
            className="floating-footer__next-button"
            disabled={!signature}
            onClick={handleSubmit}>
            Review
          </Button>
          <Button className="floating-footer__previous-button" onClick={onBack}>
            {' '}
            <img src={PreviousChevron} alt="previous-icon" />
          </Button>
        </section>
      </FormFloatingFooter>
    </section>
  )
}
